export const css = {
    root: 'lrJY5l2Y',
    heading: '_1cAL09-p',
    article: '_1AZoBHzn',
    ' _key': 'lcc-rcs/document'
};
export default css;
